import { createFileRoute } from '@tanstack/react-router';
import { authRouteOptions } from '@/lib/_auth-common-route';

export const Route = createFileRoute('/app/(auth)/login')(authRouteOptions());
